import {createTheme} from '@mui/material/styles';
import "./assets/fonts/fonts.css";

const breakpoints = {
	values: {
		xs: 0,
		sm: 600,
		md: 900,
		lg: 1200,
		xl: 1536,
	},
};

const palette = {
	primary: {
		main: '#956F56',
	},
	secondary: {
		main: '#F9F4F1',
	},
	background: {
		default: '#FCFCFC',
	},
	text: {
		primary: '#1C1C1A',
	},
	common: {
		black: '#1C1C1A',
		white: '#ffffff'
	},
};

const typography = {
	fontFamily: 'Avenir Next Condensed',
	h1: {
		fontFamily: 'Canela Light',
		fontSize: '1.863rem',
	},
	h2: {
		fontFamily: 'Canela Light',
		fontSize: '1rem',
	},
	h3: {
		fontFamily: 'Canela Light',
		fontSize: '1rem',
	},
	h4: {
		fontFamily: 'Canela Light',
		fontSize: '1rem',
	},
	h5: {
		fontFamily: 'Canela Light',
		fontSize: '1.1rem',
	},
	body: {
		fontFamily: 'Canela Light',
		fontSize: '1rem',
	},
	body1: {
		fontFamily: 'Avenir Next Condensed',
		fontSize: '1rem',
		
	},
	body2: {
		fontFamily: 'Canela Light',
		fontSize: '1rem',
	}
}

export const createCustomTheme = (customColors = {}, customFonts = {}) => {
	const themeTypography = { ...typography };
	
	if (customFonts.body) {
		// Apply custom body font; headings get it too as a fallback,
		// overridden below when a dedicated header font exists
		const bodyFontFamily = `${customFonts.body}`;
		themeTypography.fontFamily = bodyFontFamily;
		themeTypography.body = { ...themeTypography.body, fontFamily: bodyFontFamily };
		themeTypography.body1 = { ...themeTypography.body1, fontFamily: bodyFontFamily };
		themeTypography.body2 = { ...themeTypography.body2, fontFamily: bodyFontFamily };
		themeTypography.h1 = { ...themeTypography.h1, fontFamily: bodyFontFamily };
		themeTypography.h2 = { ...themeTypography.h2, fontFamily: bodyFontFamily };
		themeTypography.h3 = { ...themeTypography.h3, fontFamily: bodyFontFamily };
		themeTypography.h4 = { ...themeTypography.h4, fontFamily: bodyFontFamily };
		themeTypography.h5 = { ...themeTypography.h5, fontFamily: bodyFontFamily };
	}
	if (customFonts.header) {
		// Apply custom header font to heading variants only
		const headerFontFamily = `${customFonts.header}`;
		themeTypography.h1 = { ...themeTypography.h1, fontFamily: headerFontFamily };
		themeTypography.h2 = { ...themeTypography.h2, fontFamily: headerFontFamily };
		themeTypography.h3 = { ...themeTypography.h3, fontFamily: headerFontFamily };
		themeTypography.h4 = { ...themeTypography.h4, fontFamily: headerFontFamily };
		themeTypography.h5 = { ...themeTypography.h5, fontFamily: headerFontFamily };
	}
	
	return createTheme({
		breakpoints,
		palette: {
			...palette,
			headerBackgroundColor: customColors.headerBackgroundColor || palette.common.white,
			burgerMenuColor: customColors.burgerMenuColor || palette.primary.main,
			arrowBackColor: customColors.burgerMenuColor || palette.primary.main,
			textColor: customColors.textColor || palette.primary.main,
			footerBackgroundColor: customColors.footerBackgroundColor || palette.primary.main,
			containerBackgroundColor: customColors.containerBackgroundColor || palette.background.default,
			paperBackgroundColor: customColors.paperBackgroundColor || palette.background.default,
			listItemTextColor:  customColors.listItemTextColor || palette.primary.main,
			listItemBackgroundColor: customColors.listItemBackgroundColor || palette.common.white,
		},
		typography: themeTypography,
		components: {
			MuiBottomNavigationAction: {
				styleOverrides: {
					root: {
						color: customColors.footerTextColor || palette.background.default,
						'&:hover': {
							color: palette.common.black,
						},
						'&.Mui-selected': {
							color: customColors.footerSelectedTextColor || palette.background.default,
						},
					},
				},
			},
			MuiCssBaseline: {
				styleOverrides: {
					html: {
						overflowX: 'hidden',
						scrollBehavior: 'smooth',
					},
					body: {
						margin: 0,
						padding: 0,
						overflowX: 'hidden',
						width: '100vw',
						boxSizing: 'border-box',
						backgroundColor: customColors.containerBackgroundColor || palette.background.default,
					},
					'#root, .App': {
						minHeight: '100vh',
						display: 'flex',
						flexDirection: 'column',
						overflowX: 'hidden',
					},
				},
			},
		},
		customStyles: {
			list: {},
			slider: {},
			grid: {
				display: 'grid',
				gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))',
				gap: '15px',
				padding: '20px',
			},
			cards: {
				gap: '20px',
				padding: '20px',
			},
			buttons: {
				display: 'flex',
				flexDirection: 'row',
				justifyContent: 'center',
				gap: '10px',
				padding: '20px',
			},
			sizes: {
				small: {
					fontSize: '0.8rem',
					padding: '8px',
				},
				medium: {
					fontSize: '1rem',
					padding: '16px',
				},
				large: {
					fontSize: '1.2rem',
					padding: '24px',
				},
			},
		},
	});
};

const defaultTheme = createCustomTheme();
export default defaultTheme;
